import {
    type ShareNewsOnInstagramResponseType,
    type ShareNewsOnInstagramRequestType
} from "./type";
import {
    request
} from "../request";

const ShareNewsOnInstagram = async (params: ShareNewsOnInstagramRequestType): Promise<ShareNewsOnInstagramResponseType> => {
    return await request<ShareNewsOnInstagramResponseType>("/news/shareNewsOnInstagram", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default ShareNewsOnInstagram;
